import React, { useEffect, useState } from "react";
import { pubCall } from "../../utils/PubSub";
import { ROUTES } from "../../utils/Routes";
import { createScreen } from "../../hooks/createScreen";
import InventoryController from "../../controllers/InventoryController";

export default function BackroomNeeded(props) {

    const { controller = "", route = "", signal = {}, state = {} } = props;

    const { variant = "" } = state;

    const [results, setResults] = useState({})

    const getInitial = () => {
        let _obj = {
            report_id: variant,
            limit: 45,
            offset: 0,
        }
        pubCall("report.getRowsInitial", _obj, (_s, _r) => {
            if (_s) {
                viewReport(_r);
            }
        })
    }

    useEffect(getInitial, []);


    // Supl, Class, Floor, Back, Title, Author, ISBN, Price, ?

    const columns = [
        { min: true, key: "supplier", align: "left", title: "Supl", grow: false, width: 64 },
        { key: "class", title: "Class", width: 130, },
        { key: "floor", title: "Floor", width: 45, },
        { key: "back", title: "Back", width: 45, },
        { key: "title", title: "Title", width: 150, },
        { key: "author", title: "Author", width: 150, },
        { key: "isbn", title: "ISBN", width: 160, },
        { key: "condition", title: "Condition", width: 30, },
        { key: "price", title: "Price", width: 30, },
        { key: "notes", title: "Notes", width: 30, }
    ];

    const viewReport = (_data) => {


        let _obj = {
            "columns": columns,
            "ignore_parse": true,
            "filters": [],
            "name": "Backroom stock needed on sales floor",
            "report_id": variant,
        }



        window.bm_state.value = ROUTES.INVENTORY.INVENTORY;
        createScreen({
            is_modal: true,
            // target: inventoryRef.current,
            signal,
            component: (
                <InventoryController
                    showPrintExport={true}
                    controller={controller}
                    is_modal={_obj}
                    // expand={true}
                    route={ROUTES.INVENTORY.INVENTORY}
                />
            ),
            closable: false,
            title: "Select Customer",
            callback: () => {
                if (
                    window.bm_state.value === ROUTES.INVENTORY.INVENTORY
                ) {
                    window.bm_state.value = route;
                }
            }
        });

    }



    return (
        <>
            <div className="controller component-layout">
                <pre>{JSON.stringify(results, null, 2)}</pre>
            </div>
        </>
    )
}